import ReferPatientDocuments from "./ReferPatientDocuments";

export default ReferPatientDocuments;
